/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { LocaleLink } from "utilities/NavigationUtilities";
import { AppPath } from "components/AppPath";
import myProjectsIcon from "./my-projects-button.svg";

const LinkContainer = styled(LocaleLink)`
  text-decoration: none;
  color: var(--spectrum-gray-800);
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
`;

export const MyProjectsButton: React.FC = () => {
  return (
    <LinkContainer to={AppPath.STUDIO}>
      <sp-button treatment="outline" size="l" variant="secondary">
        <img
          src={myProjectsIcon}
          slot="icon"
          aria-hidden="true"
          alt={I18n.t("links.my_projects")}
        />
        {I18n.t("links.my_projects")}
      </sp-button>
    </LinkContainer>
  );
};
